let orderTrigger;
const originalRows = new WeakMap();

function resetOrderDialog(dialog) {
  dialog.querySelectorAll("[data-host-offer-order-list]").forEach((list) => {
    if (!originalRows.has(list)) originalRows.set(list, Array.from(list.children));
    originalRows.get(list).forEach((row) => list.append(row));
    updateRows(list);
  });
  dialog.querySelector("[data-host-offer-order-announcement]").textContent = "";
}

function updateRows(list) {
  Array.from(list.children).forEach((row, index) => {
    row.querySelector("[data-host-offer-order-position]").textContent = index + 1;
    row.querySelector('[data-host-offer-order-move="up"]').disabled = index === 0;
    row.querySelector('[data-host-offer-order-move="down"]').disabled = index === list.children.length - 1;
  });
}

function selectHotel(dialog) {
  const hotel = dialog.querySelector("[data-host-offer-order-hotel]").value;
  dialog.querySelectorAll("[data-host-offer-order-form]").forEach((form) => {
    form.hidden = form.dataset.hostOfferOrderForm !== hotel;
  });
}

document.addEventListener("click", (event) => {
  const trigger = event.target.closest?.("[data-host-offer-order-open]");
  if (trigger) {
    const dialog = document.querySelector("[data-host-offer-order-dialog]");
    if (!dialog) return;
    orderTrigger = trigger;
    resetOrderDialog(dialog);
    selectHotel(dialog);
    dialog.showModal();
    dialog.querySelector("[data-host-offer-order-hotel]").focus();
    return;
  }

  const dialog = event.target.closest?.("[data-host-offer-order-dialog]");
  if (!dialog) return;
  if (event.target === dialog || event.target.closest("[data-host-offer-order-close]")) {
    dialog.close();
    return;
  }

  const button = event.target.closest("[data-host-offer-order-move]");
  if (!button || button.disabled) return;
  const row = button.closest("[data-host-offer-order-row]");
  const list = row.parentElement;
  if (button.dataset.hostOfferOrderMove === "up") {
    row.previousElementSibling?.before(row);
  } else {
    row.nextElementSibling?.after(row);
  }
  updateRows(list);
  const position = Array.from(list.children).indexOf(row) + 1;
  const announcement = dialog.querySelector("[data-host-offer-order-announcement]");
  announcement.textContent = announcement.dataset.template
    .replace("__TITLE__", () => row.dataset.title)
    .replace("__POSITION__", () => position)
    .replace("__COUNT__", () => list.children.length);
  // Keep keyboard focus on this offer when the clicked arrow reaches an edge.
  (button.disabled ? row.querySelector("[data-host-offer-order-move]:not(:disabled)") : button)?.focus();
});

document.addEventListener("change", (event) => {
  if (event.target.matches?.("[data-host-offer-order-hotel]")) {
    const dialog = event.target.closest("[data-host-offer-order-dialog]");
    resetOrderDialog(dialog);
    selectHotel(dialog);
  }
});

document.addEventListener("close", (event) => {
  if (!event.target.matches?.("[data-host-offer-order-dialog]")) return;
  resetOrderDialog(event.target);
  orderTrigger?.focus();
}, true);

document.addEventListener("turbo:before-cache", () => {
  const dialog = document.querySelector("[data-host-offer-order-dialog]");
  orderTrigger = null;
  if (dialog) {
    dialog.close();
    resetOrderDialog(dialog);
  }
});
